<!--
 * @Author: your name
 * @Date: 2022-03-30 17:49:59
 * @LastEditTime: 2022-05-26 16:18:06
 * @LastEditors: Jokersora 674077946@qq.com
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \mingyao\src\views\Power.vue
-->
<template>
  <div class="power">
    <div class="para">
      <div class="tit">公司资质</div>
      <div class="txt">
      本公司具有建筑机电安装工程专业承包贰级、消防设施工程专业承包贰级资质、建筑装饰装修工程专业承包贰级资质、电子与智能化工程专业承包贰级资质、特种工程专业承包（结构补强）资质、消防检测维保专项资质。
      </div>
    </div>
    <div class="para">
      <div class="tit tit1">资质证书展示</div>
      <div class="imgs">
        <img
          v-for="i in 2"
          :key="i"
          :src="require('../assets/images/q' + i + '.jpg')"
        />
      </div>
    </div>
    <div class="para">
      <div class="tit tit1">人员资质展示</div>
      <div class="txt">
        本公司注册资金3600万元人民币，设有总经理室、工程部、市场部、财务部、售后服务部。现有在册员工50余人，其中高级工程师2人、工程师8人、助理工程师8人、一级建造师5人，二级建造师9人，经专业培训持有特种操作证的员工15人。大专以上学历者占员工总数的90%。
      </div>
      <div class="imgs">
        <img
          v-for="i in 10"
          :key="i"
          :class="i==5||i==6?'w':''"
          :src="require('../assets/images/qq' + i + '.jpg')"
        />
      </div>
    </div>
    <Root />
  </div>
</template>

<script>
import Root from "@/components/Root.vue";
export default {
  name: "Power",
  components: {
    Root,
  },
};
</script>

<style lang="less" scoped>
.para {
  padding: 1rem 20% 1rem 20%;
  display: inline-block;
  width: 100%;
}
.tit {
  font-size: 1.5rem;
  color: rgb(27, 151, 243);
  border-left: 5px solid rgb(27, 151, 243);
  padding-left: 0.5rem;
  font-weight: bold;
  text-align: left;
  margin-bottom: 0.5rem;
}
.tit1 {
  font-size: 1.25rem;
}
.txt{
    text-align: left;
}
.imgs img {
  width: 50%;
}
.imgs .w{
  width:100%;
}
</style>